(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faq-section"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const openFaq = (toggle) => {
      const answer = toggle.nextElementSibling;
      toggle.classList.add('is-open');
      answer.classList.add('is-open');
      answer.style.height = answer.scrollHeight + 'px';
    };

    const closeFaq = (toggle) => {
      const answer = toggle.nextElementSibling;
      toggle.classList.remove('is-open');
      answer.classList.remove('is-open');
      answer.style.height = '0';
    };

    const openFromHash = () => {
      const hash = decodeURIComponent(location.hash.slice(1));
      if (!hash) return;

      const topic = document.getElementById(hash);
      if (!topic || !topic.classList.contains('js-faq')) return;

      const toggle = topic.querySelector('.js-faq-toggle');
      if (!toggle) return;

      openFaq(toggle);
      topic.scrollIntoView({ behavior: 'smooth', block: 'start' });
    };

    window.addEventListener('load', () => {
      document.querySelectorAll('.js-faq-toggle').forEach((toggle) => {
        toggle.addEventListener('click', () => {
          toggle.classList.contains('is-open') ? closeFaq(toggle) : openFaq(toggle);
        });
      });

      openFromHash();
    });

    window.addEventListener('hashchange', openFromHash);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    

document.addEventListener('DOMContentLoaded',function(){
  const toTop = document.querySelectorAll('.js-to-top');
  [...toTop].map((btn) => {
    btn.addEventListener('click', function(){
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
const sh_toggleButton = document.querySelector('[data-sh-menu-toggle]');
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }
  }

  customElements.define('sticky-header', StickyHeader);

  // dropdown
  const dropdownToggles = document.querySelectorAll('.js-dropdown-toggle');
  dropdownToggles.forEach(function (btn) {
    const parent = btn.closest('.js-dropdown-parent');
    const submenu = parent.querySelector('.js-dropdown-div');

    btn.dataset.submenuHeight = submenu.firstElementChild.offsetHeight;

    function openSubmenu(parent,btn,submenu) {
      parent.classList.add('is-open');
      btn.classList.add('is-open');
      submenu.style.maxHeight = btn.dataset.submenuHeight + 'px';
    }
    function closeSubmenu(parent) {
      parent.classList.remove('is-open');
      parent.querySelector('.js-dropdown-toggle').classList.remove('is-open');
      parent.querySelector('.js-dropdown-div').style.maxHeight = 0;
    }

    btn.addEventListener('click', function (e) {
      e.preventDefault();
      
      const isOpen = parent.classList.contains('is-open');
      const allParents = document.querySelectorAll('.js-dropdown-parent');
      allParents.forEach(function (parent) {
        closeSubmenu(parent);
      });
      if (!isOpen) {
        openSubmenu(parent,btn,submenu)
        submenu.focus();
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-guide-page"]) return;
  try {
    
window.addEventListener('load', () => {
  // 初期表示時
  let heightGet = document.querySelector('.js-height-target').clientHeight;
  let heightTarget = document.querySelector('.js-height-adjustment');
  heightTarget.style.height = heightGet + 'px';
  window.addEventListener('resize', () => {
    heightGet = document.querySelector('.js-height-target').clientHeight;
    heightTarget = document.querySelector('.js-height-adjustment');
    heightTarget.style.height = heightGet + 'px';
  })
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reward"] && !Shopify.designMode) return;
  try {
    

  
    document.querySelectorAll(".openModal").forEach(button => {
      button.addEventListener("click", function(event) {
        event.preventDefault();
        document.querySelector(".modal").style.display = "block";
      });
    });
    
    document.querySelector(".closeModal").addEventListener("click", function() {
      document.querySelector(".modal").style.display = "none";
    });
    
    window.addEventListener("click", function(event) {
      if (event.target.classList.contains("modal")) {
        event.target.style.display = "none";
      }
    });
  if (!window.submitExchange) {
    window.submitExchange = async (variantId, element, productId, requiresShipping, rewardPoint) => {
      if (!variantId) return;

      // Disable all exchange buttons
      document.querySelectorAll('[id^="exchange-button-"]').forEach((button) => {
        button.disabled = true;
      });

      const url = '/apps/pointapi/exchange/shopifyproduct';
      const params = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          variant_id: variantId,
          product_id: productId,
          requires_shipping: requiresShipping === 'true',
          reward_point: parseInt(rewardPoint, 10),
        }),
      };

      try {
        const response = await fetch(url, params);
        const data = await response.json();
        if (data.status === 'success' && data.data.checkout_url) {
          document.location = data.data.checkout_url;
        } else {
          // Hide all error messages first
          document.querySelectorAll(`[id^="error-"][id$="-${productId}"]`).forEach((el) => {
            el.style.display = 'none';
          });

          // Show specific error message based on error code
          if (data.data.error_code === 'exchange_limit_error') {
            document.getElementById(`error-limit-${productId}`).style.display = 'block';
          } else if (data.data.error_code === 'exchange_point_error') {
            document.getElementById(`error-point-${productId}`).style.display = 'block';
          } else if (data.data.error_code === 'exchange_date_range_error') {
            document.getElementById(`error-date-range-limit-${productId}`).style.display = 'block';
          }

          // Re-enable exchange button
          document.querySelectorAll('[id^="exchange-button-"]').forEach((button) => {
            button.disabled = false;
          });
        }
      } catch (error) {
        console.error('Error:', error);
        // On error, re-enable all exchange buttons
        document.querySelectorAll('[id^="exchange-button-"]').forEach((button) => {
          button.disabled = false;
        });
      }
    };
  }

  if (!customElements.get('reward-variant-selects')) {
    class RewardVariantSelects extends HTMLElement {
      constructor() {
        super();
        this.setupEventListeners();
        this.productData = JSON.parse(this.querySelector('script[type="application/json"]').textContent);
        this.productId = this.productData.id;
        this.requiresShipping = this.dataset.requiresShipping;
        this.rewardPoint = this.dataset.rewardPoint;
        this.updateButtonState();
      }

      setupEventListeners() {
        this.querySelectorAll('select').forEach((select) => {
          select.addEventListener('change', this.onVariantChange.bind(this));
        });
      }

      onVariantChange(event) {
        if (!event.target.matches('select')) return;
        this.getSelectedOptions();
        this.getSelectedVariant();
        this.updateVariantInput();
        this.updateVariantImage();
        this.updateButtonState();
      }

      getSelectedOptions() {
        this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
      }

      getSelectedVariant() {
        if (!this.productData || !this.productData.variants) return;

        this.currentVariant = this.productData.variants.find((variant) => {
          return !variant.options
            .map((option, index) => {
              return this.options[index] === option;
            })
            .includes(false);
        });
      }

      updateButtonState() {
        const button = this.querySelector('button');
        if (!button) return;

        let isAvailable = false;
        let variantId = null;

        if (this.productData.has_only_default_variant) {
          isAvailable = this.productData.available;
          variantId = this.productData.variants[0].id;
        } else if (this.currentVariant) {
          isAvailable = this.currentVariant.available;
          variantId = this.currentVariant.id;
        } else {
          isAvailable = this.productData.variants.some((variant) => variant.available);
          variantId = this.productData.variants.find((v) => v.available)?.id;
        }

        if (!isAvailable) {
          button.classList.add('disabled');
          button.setAttribute('disabled', '');
          button.textContent = '在庫切れ';
        } else {
          button.classList.remove('disabled');
          button.removeAttribute('disabled');
          button.textContent = '交換する';
          button.setAttribute('data-variant-id', variantId);
          button.onclick = () =>
            submitExchange(variantId, button, this.productId, this.requiresShipping, this.rewardPoint);
        }

        // エラーメッセージの表示を更新
        const stockError = document.querySelector(`#error-stock-${this.productId}`);
        if (stockError) {
          stockError.style.display = !isAvailable ? 'block' : 'none';
        }
      }

      updateVariantInput() {
        const input = this.querySelector('input[name="id"]');
        if (input && this.currentVariant) {
          input.value = this.currentVariant.id;
        }
      }

      updateVariantImage() {
        if (!this.currentVariant || !this.currentVariant.featured_image) return;

        const imageWrapper = document.querySelector(`.reward__image-wrapper[data-product-id="${this.productId}"]`);
        if (!imageWrapper) return;

        const image = imageWrapper.querySelector('.reward__image');
        if (!image) return;

        const newImage = this.currentVariant.featured_image;
        image.src = newImage.src;
        image.alt = newImage.alt || '';
      }
    }

    customElements.define('reward-variant-selects', RewardVariantSelects);
  }

  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["swiper-slideshow"] && !Shopify.designMode) return;
  try {
    
const swiper = new Swiper('.js-slider-swiper', {
  slidesPerView: '1',
  loop: true,
  spaceBetween: 10,
  //createElements: true,
  watchSlidesProgress: true,
  centeredSlides: true,
  speed: 1500,
  autoplay: {
    delay: 5000,
    disableOnInteraction: false,
    pauseOnMouseEnter: true,
  },
  

  // If we need pagination
  pagination: {
    el: '.swiper-pagination',
    type: 'bullets',
    clickable: true
  },

  // Navigation arrows
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
});

  } catch(e) { console.error(e); }
})();
})();
